module.exports = __webpack_public_path__ + "img/dining-room.73bd8b22.svg";